module.exports = __webpack_public_path__ + "img/1723129315700-roti-bakar-bandung-chocolate-spread-260nw-2311888095.webp.f22f64ce.webp";